import React from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from 'antd';

import {
  exportBostaCreditsInfo,
  exportInsuranceInfo,
  exportCashOutInfo
} from 'services/business';
import {
  ANALYSIS_EXPORT_BUTTONS_IDS,
  INSURANCE_STATUSES
} from 'constants/Businesses';

import StatisticsPie from '../components/cards/StatisticsPie/StatisticsPie';
import StatCard from '../components/StatCard/StatCard';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as InfoIcon } from 'assets/bosta-icons/Info-Circle.svg';
import { ReactComponent as CoinsStacked } from 'assets/bosta-icons/coins-stacked.svg';
import { ReactComponent as CoinsSwap } from 'assets/bosta-icons/coins-swap.svg';
import { ReactComponent as CertificateIcon } from 'assets/bosta-icons/certificate-icon.svg';

import './OverallAnalytics.less';

const OverallAnalytics = ({ analytics, setIsLoading, ...props }) => {
  const intl = useIntl();

  const { INSURANCE_STATISTICS, BOSTA_CREDITS, CASH_OUT } =
    ANALYSIS_EXPORT_BUTTONS_IDS;

  const exportFunctions = {
    [INSURANCE_STATISTICS]: exportInsuranceInfo,
    [BOSTA_CREDITS]: exportBostaCreditsInfo,
    [CASH_OUT]: exportCashOutInfo
  };

  const handleExportButton = async (cardId) => {
    if (!cardId) return;

    setIsLoading(true);

    try {
      const { data } = await exportFunctions[cardId]();

      notify(data, 'success');
    } catch (error) {
      notify(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="br-overall-analytics__container">
      <div className="br-overall-analytics__container-left-section">
        <StatCard
          title={intl.formatMessage({
            id: 'merchant_analysis.insurance_statistics'
          })}
          titleIcon={
            <CertificateIcon className="br-overall-analytics__card-header-icon" />
          }
          className="br-statistics-pie"
          handleExportOnClick={() => handleExportButton(INSURANCE_STATISTICS)}
          showExportButton
        >
          <StatisticsPie
            rawData={analytics?.pieData}
            referenceData={INSURANCE_STATUSES}
            businessCount={analytics?.businessCount}
          />
        </StatCard>
      </div>

      <div className="br-overall-analytics__container-right-section">
        <StatCard
          title={intl.formatMessage({
            id: 'merchant_analysis.bosta_credits_title'
          })}
          titleIcon={
            <CoinsStacked className="br-overall-analytics__card-header-icon" />
          }
          handleExportOnClick={() => handleExportButton(BOSTA_CREDITS)}
          showExportButton
        >
          <div className="br-overall-analytics__container-right-section-info">
            <span>
              {analytics?.bostaCredits.toLocaleString(undefined, {
                minimumFractionDigits: 2
              })}
            </span>

            <span>
              {intl.formatMessage({ id: 'merchant_analysis.credit' })}
            </span>
          </div>
        </StatCard>
        <StatCard
          title={intl.formatMessage({ id: 'merchant_analysis.cashOut_title' })}
          titleIcon={
            <CoinsSwap className="br-overall-analytics__card-header-icon" />
          }
          extraTitleContent={
            <Tooltip
              title={intl.formatMessage({
                id: 'merchant_analysis.cashOut_disclaimer'
              })}
              placement={'right'}
              overlayClassName="br-overall-analytics__cashOut-tooltip"
              color="#1C2A3A"
            >
              <InfoIcon className="info-icon" />
            </Tooltip>
          }
          handleExportOnClick={() => handleExportButton(CASH_OUT)}
          showExportButton
        >
          <div className="br-overall-analytics__container-right-section-info">
            <span>{analytics?.cashOut.toLocaleString()}</span>
            <span>
              {intl.formatMessage({ id: 'merchant_analysis.businesses' })}
            </span>
          </div>
        </StatCard>
      </div>
    </div>
  );
};

export default OverallAnalytics;
